<template>
  <button :class="classes" @click="doClick" title="Notifications">
    <block-spinner :active="isActive" size="5" :color="spinnerColor" :key="`spinner_${isActive}`"></block-spinner>
    <p v-if="!isActive">Turn {{ OnOrOff }} notifications</p>
  </button>
</template>

<script>
  export default {
    name: 'NotificationsBtn',

    props: {
      alert: {
        type: [Object, String],
      }
    },

    data() {
      return {
        isActive: false
      }
    },

    mounted() {

    },

    methods: {
      doClick() {
        this.isActive = !this.isActive;
        this.isActive ? this.createNotification() : this.cancelNotification();
      },
      createNotification() {
        // create notification for searches/alerts
        console.log('create notification for searches/alerts', this.alert);
      },
      cancelNotification() {
        // cancel notification for searches/alerts
        console.log('cancel notification for searches/alerts', this.alert);
      },
      spinnerColor() {
				return this.isActive ? 'text-red' : 'text-green';
			}
    },

    computed: {
      classes() {
        return {
          'btn btn-notification': true,
          'active': this.isActive,
        }
      },
      OnOrOff() {
        return this.isActive ? 'off' : 'on';
      }
    }
  };
</script>
